module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<%\n    // support for s24 widget\n    var view_abc_header = view_abc_header || { background_image: {} };\n    var abcHeaderBg = view_abc_header.background_image;\n%> <%= abcHeaderBg.desktop ? namespace + ' .view-abc-header { background-image: url(' + abcHeaderBg.desktop + ');}' : '' %> <%= abcHeaderBg.size? namespace + ' .view-abc-header { background-size: url(' + abcHeaderBg.size + ');}' : '' %> <%= abcHeaderBg.position? namespace + ' .view-abc-header { background-position: url(' + abcHeaderBg.position + ');}' : '' %> /* Media Queries */ @media( max-width: 749px ){ <%= abcHeaderBg.tablet ? namespace + ' .view-abc-header { background-image: url(' + abcHeaderBg.tablet + ');}' : '' %> } @media( max-width: 374px ){ <%= abcHeaderBg.mobile ? namespace + ' .view-abc-header { background-image: url(' + abcHeaderBg.mobile + ');}' : '' %> } ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('');__stack.lineno=1;
    // support for s24 widget
    var view_abc_header = view_abc_header || { background_image: {} };
    var abcHeaderBg = view_abc_header.background_image;
; buf.push(' ', escape((__stack.lineno=5,  abcHeaderBg.desktop ? namespace + ' .view-abc-header { background-image: url(' + abcHeaderBg.desktop + ');}' : '' )), ' ', escape((__stack.lineno=5,  abcHeaderBg.size? namespace + ' .view-abc-header { background-size: url(' + abcHeaderBg.size + ');}' : '' )), ' ', escape((__stack.lineno=5,  abcHeaderBg.position? namespace + ' .view-abc-header { background-position: url(' + abcHeaderBg.position + ');}' : '' )), ' /* Media Queries */ @media( max-width: 749px ){ ', escape((__stack.lineno=5,  abcHeaderBg.tablet ? namespace + ' .view-abc-header { background-image: url(' + abcHeaderBg.tablet + ');}' : '' )), ' } @media( max-width: 374px ){ ', escape((__stack.lineno=5,  abcHeaderBg.mobile ? namespace + ' .view-abc-header { background-image: url(' + abcHeaderBg.mobile + ');}' : '' )), ' } '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/templates/css.ejs
// module id = 292
// module chunks = 0